export const hasPermission = (currentUser, permission) => {
  const permissions =
    (currentUser &&
      currentUser.permissions &&
      currentUser.permissions.length &&
      currentUser.permissions.map(p => p.toLowerCase())) ||
    [];

  return permissions.includes(permission.toLowerCase());
};

export const PERMISSIONS = {
  FETCH_LIVE_MONITOR: 'fetch.live.monitor',
  FETCH_CAMPAIGN: 'fetch.campaign',
  CREATE_CAMPAIGN: 'create.campaign',
  FETCH_FEATURE_ALL: 'fetch.feature.all',
  FETCH_MENU_PULLING: 'fetch.menu.pulling',
  FETCH_CRM_ALL: 'fetch.crm.all',
  FETCH_INVOICE: 'fetch.invoice',
  FETCH_ENGAGEIT: 'fetch.engageit',
  FETCH_PIXEL_TRACKING: 'fetch.pixel.tracking',
  // Partner API admin section. Mirrors partner-api consts +
  // core/consts/const.go's PermissionPartnerAPI* family.
  PARTNER_API_ACCESS: 'partner.api.access',
  PARTNER_API_ACTIVITY: 'partner.api.activity',
  FETCH_INVENTORY_STOCK: 'fetch.inventory.stock',
  APPROVE_STOCKTAKE: 'approve.stocktake',
  UPDATE_INVENTORY_CONFIG: 'update.inventory.config',
  FETCH_WEBHOOK_REPLAY: 'fetch.webhook.replay',
};
